// App.js
import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./components/firebase";
import "./App.css";

import Login from "./components/Login";
import ResetPassword from "./components/ResetPassword";
import Home from "./components/Home";

export default function App() {
  const [user, setUser] = useState(null);
  const [screen, setScreen] = useState("login"); // "login", "reset", "home"

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setScreen(currentUser ? "home" : "login");
    });
    return () => unsubscribe();
  }, []);

  if (!user) {
    if (screen === "login") {
      return <Login onLogin={(next) => setScreen(next || "home")} />;
    } else if (screen === "reset") {
      return <ResetPassword onBack={() => setScreen("login")} />;
    }
  } else {
    // Only regular user screen
    return <Home user={user} />;
  }

  return null;
}
